export enum IrisNotificationPriorityEnum {
  Minor = 'Minor',
  Normal = 'Normal',
  Major = 'Major',
  Critical = 'Critical',
  Blocker = 'Blocker',
}
